import { SupportedCurrency } from './currency';
import { TransportOrderStatus } from './transportOrder';

export type CreatorStatsEntity = {
    id: string;
    name: string;
    orderCount: Record<TransportOrderStatus, number>;
    totalProfit: number;
    averageProfit: number;
    minProfit: number;
    maxProfit: number;
    totalFreightValue: number;
    averageFreightValue: number;
    baseCurrency: SupportedCurrency;
}

export type ContractorStatsEntity = {
    id: string;
    name: string;
    orderCount: Record<TransportOrderStatus, number>;
    totalProfit: number;
    averageProfit: number;
    minProfit: number;
    maxProfit: number;
    totalFreightValue: number;
    averageFreightValue: number;
    baseCurrency: SupportedCurrency;
}

export type ProfitStatsGranulation = 'DAY' | 'MONTH';

export type DailyProfitStats = {
    daysInSelectedMonth: number;
    profits: Array<{ dayNumber: number, value: number; }>;
    cumulativeProfits: Array<number>;
}

export type MonthlyProfitStats = {
    profits: Array<{
        month: number;
        year: number;
        value: number;
        numberOfActiveOrders: number;
    }>;
    cumulativeProfits: Array<number>;
}

export type BaseProfitStats = {
    minProfit: number;
    maxProfit: number;
    total: number;
}

export type ProfitStatsEntity = {
    granulation: ProfitStatsGranulation;
} & {
    [currency in SupportedCurrency]?: BaseProfitStats & (DailyProfitStats | MonthlyProfitStats);
};

export type CombinedDailyProfitStats = {
    granulation: ProfitStatsGranulation;
} & {
    [currency in SupportedCurrency]?: BaseProfitStats & DailyProfitStats;
};
export type CombinedMonthlyProfitStats = {
    granulation: ProfitStatsGranulation;
} & {
    [currency in SupportedCurrency]?: BaseProfitStats & MonthlyProfitStats;
};

export type StatsEntity = {
    creatorsStats: Array<CreatorStatsEntity>;
    contractorsStats: Array<ContractorStatsEntity>;
    transportOrdersStatusStats: Record<TransportOrderStatus, number>;
    profitStats: ProfitStatsEntity;
    creatorsStatsForAppliedContractor?: {
        contractor: {
            id: string;
            // name: string;
        }
        stats: Array<CreatorStatsEntity>;
    };
    contractorsStatsForAppliedCreator?: {
        creator: {
            id: string;
            // name: string;
}
        stats: Array<ContractorStatsEntity>;
    };
}


export function isProfitStatsDaily(stats: ProfitStatsEntity): stats is CombinedDailyProfitStats {
    return stats.granulation === 'DAY';
}

export function isProfitStatsMonthly(stats: ProfitStatsEntity): stats is CombinedMonthlyProfitStats {
    return stats.granulation === 'MONTH';
}
